export default {"src":"/_next/static/image/public/images/user_image.1a0633a548c82a7ec7b3eab46262f11b.svg","height":50,"width":50};